import type { Readable } from 'node:stream';

/**
 * Pipe child output through `onData` (tails, firehose, etc.). If `terminal` is set, also echo to
 * the CLI (with backpressure). Pass `null` for `terminal` to capture only.
 */
export function forwardChildPipe(
  childReadable: Readable | null | undefined,
  terminal: NodeJS.WriteStream | null,
  onData: (chunk: Buffer) => void,
): void {
  if (!childReadable) return;
  childReadable.on('data', (chunk: Buffer) => {
    onData(chunk);
    if (!terminal || terminal.writableEnded) return;
    const ok = terminal.write(chunk);
    if (!ok) {
      childReadable.pause();
      terminal.once('drain', () => {
        childReadable.resume();
      });
    }
  });
}
